import { useFormikContext } from 'formik'
import Button from 'ui/components/buttons/Button/'
import { notifyError } from 'ui/components/Notify'
import Checklist from './components/Checklist'
import { MAX_CHECKLISTS } from './constants'
import { createChecklists } from './helpers'
import {
  ChecklistFormContainer,
  ChecklistsWrap,
  ButtonContainer,
} from './styled'

const ChecklistForm = () => {
  const formik = useFormikContext()
  const checklists = formik.getFieldProps('checklists').value ?? []

  const addChecklistHandler = () => {
    if (checklists.length === MAX_CHECKLISTS) {
      notifyError('Добавлено максимальное количество чек-листов')
    } else {
      formik.setFieldValue('checklists', [...checklists, createChecklists()])
    }
  }

  return (
    <ChecklistFormContainer>
      {checklists.length > 0 && (
        <ChecklistsWrap>
          {checklists.map((checklist, checklistIndex) => (
            <Checklist
              key={checklistIndex}
              checklist={checklist}
              checklistIndex={checklistIndex}
            />
          ))}
        </ChecklistsWrap>
      )}
      <ButtonContainer expanded={checklists?.length > 0}>
        <Button
          type="button"
          title={
            checklists?.length > 0
              ? 'Добавить еще чек-лист'
              : 'Добавить чек-лист'
          }
          theme="borderBlue"
          onClick={addChecklistHandler}
        />
      </ButtonContainer>
    </ChecklistFormContainer>
  )
}

export default ChecklistForm
